import { render, staticRenderFns } from "./ax.vue?vue&type=template&id=c885e61a&scoped=true&"
import script from "./ax.vue?vue&type=script&lang=js&"
export * from "./ax.vue?vue&type=script&lang=js&"
import style0 from "./ax.vue?vue&type=style&index=0&id=c885e61a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c885e61a",
  null
  
)

export default component.exports